import { useReducer } from 'react'
import moment from 'moment'

const initialState = {
  isOpen: false,
  initialModel: {
    id: undefined,
    title: undefined,
    body: undefined,
    description: undefined,
    limitedAmount: undefined,
    templateId: undefined,
    isAttached: false,
    status: undefined,
    voucher: {
      startDateTime: null,
      endDateTime: null,
    },
  },
}

const HANDLE_OPEN_DIALOG = 'open'
const HANDLE_CLOSE_DIALOG = 'success'
const SET_VOUCHER_DATA = 'setVoucher'

const reducer = (state, action) => {
  switch (action.type) {
    case HANDLE_OPEN_DIALOG:
      return {
        ...state,
        isOpen: true,
      }
    case HANDLE_CLOSE_DIALOG:
      return {
        ...state,
        isOpen: false,
        initialModel: initialState.initialModel,
      }

    case SET_VOUCHER_DATA:
      return {
        ...state,
        initialModel: {
          id: action.payload.id,
          title: action.payload.title,
          body: action.payload.body,
          description: action.payload.description,
          limitedAmount: action.payload.limitedAmount,
          templateId: action.payload.templateId,
          status: action.payload.status,
          isAttached: action.payload.isAttached,
          voucher: {
            startDateTime: moment(action.payload.startDate).local().format(),
            endDateTime: moment(action.payload.endDate).local().format(),
          },
        },
      }
    default:
      return state
  }
}

export default () => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const onOpenVoucherFormDialog = () => {
    dispatch({ type: HANDLE_OPEN_DIALOG })
  }

  const handleSetVoucherData = (values) => {
    dispatch({
      type: SET_VOUCHER_DATA,
      payload: values,
    })
  }

  const onCloseVoucherFormDialog = () => {
    dispatch({ type: HANDLE_CLOSE_DIALOG })
  }

  return [
    state,
    onOpenVoucherFormDialog,
    onCloseVoucherFormDialog,
    handleSetVoucherData,
  ]
}
